    <template>
  <div class="generator flex flex-wrap -mx-2">
    <div class="w-full lg:w-2/3 px-2" v-if="build.build" :data-type="type">
      <h1>Zutaten ändern: {{ build.product.item_title }} ({{ build.build.humanSize }})</h1>

      <h2 class="mt-4 text-xl ingredients">Enthaltene Zutaten</h2>
      <ul class="includedingredients flex flex-wrap list-reset mb-8">
        <li v-for="(ingredient) in sortedRealIngredients" v-if="ingredient.count > 0" class="border-solid border-grey-darker w-full lg:w-1/3 xl:w-1/4 mr-2 mb-2"
          :style="`background-image: url('${ingredient.images.thumb}')`">
          <span v-if="ingredient.count == 2">doppelt</span>
          <span v-if="ingredient.count == 3">dreifach</span>
          {{ ingredient.title }}
          <nobr v-if="ingredient.count != ingredient.included">{{ ingredient.price | pricetag }}</nobr>
          <span class="removeingredient" tabindex="0" v-on:keydown.enter.prevent="removeingredient(ingredient.id)" v-on:keydown.space.prevent="removeingredient(ingredient.id)" v-on:click="removeingredient(ingredient.id)">❌</span>
        </li>
      </ul>

      <div class="flex flex-wrap">
        <div class="w-full md:w-1/2 lg:w-1/3 mb-4 mr-4">
          <div class="generator_base">
            <div
              v-for="(ingredient) in previewIngredients"
              v-if="ingredient.count > 0"
              class="ingredient"
              :style="`top: ${ingredient.marginTop}px`"
            >
              <div v-for="i in ingredient.count" class="ingredient__image" :style="`background-image: url('${ingredient.images.image}');`"></div>
            </div>
          </div>
        </div>
        <div class="w-full md:w-1/2 lg:w-2/3 mb-4 -mr-4">
          <h3>Verfügbare Zutaten</h3>
          <ul class="availableIngredients flex flex-wrap list-reset">
            <li v-for="ingredient in availableIngredients" v-bind:key="ingredient.id" tabindex="0" v-on:keydown.enter.prevent="addingredient(ingredient.id, $event)" v-on:keydown.space.prevent="addingredient(ingredient.id, $event)" v-on:click="addingredient(ingredient.id, $event)" class="zoomhover border-solid border-grey-darker w-full lg:w-1/3 xl:w-1/4 mr-2 mb-2"
              :style="`background-image: url('${ingredient.thumb}')`">
              {{ ingredient.item_title }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="w-full z-40 bg-white lg:min-h-full lg:w-1/3 fixed pin-b pin-l lg:pin-none lg:pin-t lg:h-full lg:pin-r minibasket-container px-2 overflow-auto max-h-screen">
      <basketcomponent viewtype="generator"></basketcomponent>
    </div>
  </div>
</template>

<script>
import endpoints from '../../endpoints'
import Basketcomponent from '../../components/Basketcomponent.vue'
import axios from 'axios'
import { mapActions } from 'vuex'

export default {
  name: 'Generator',

  data () {
    return {
      hostId: window.hostId,
      build: {
        product: {
          item_title: ''
        },
        build: {
          humanSize: ''
        }
      },
      type: '',
      availableIngredients: {},
      errors: []
    }
  },

  created () {
    this.getBuild()
    this.getAvailableIngredients()
  },

  components: {
    'basketcomponent': Basketcomponent
  },

  watch: {
    '$route' (to, from) {
      this.getBuild()
      this.getAvailableIngredients()
    }
  },

  computed: {
    sortedRealIngredients() {
      return _.sortBy(this.build.build.realingredis, [function(o) { return parseInt(o.sort); }])
    },

    previewIngredients() {
      let ingredients = this.sortedRealIngredients
      let sum = 0

      if(this.type === 'burger') {
        // set item position
        _.each(ingredients, (value, key) => {
          sum += parseInt(value.item_on_burger_height)
          ingredients[key].marginTop = sum
        })

        // fix all positions
        _.each(ingredients, (value, key) => {
          ingredients[key].marginTop = (sum - value.marginTop)
        })
      }

      return ingredients
    }
  },

  methods: {
    ...mapActions([
      'updateBasket'
    ]),

    getBuild () {
      axios.post(endpoints.build, {
        'buildId': Number(this.$route.params.id)
      })
        .then(response => {
          this.build = response.data
          this.type = response.data.product.item_generator
        })
        .catch(e => {
          this.errors.push('Deine Konfiguration konnte nicht geladen werden 😭')
        })
    },

    getAvailableIngredients () {
      axios.post(endpoints.availableIngredients, {
        'buildId': Number(this.$route.params.id)
      })
        .then(response => {
          this.availableIngredients = response.data
        })
        .catch(e => {
          this.errors.push('Die Zutaten konnten nicht geladen werden 😭')
        })
    },

    addingredient (ingredientId, event) {
      event.target.classList.add('loading')

      axios.post(endpoints.addIngredient, {
        'buildId': Number(this.$route.params.id),
        'ingredientId': Number(ingredientId)
      })
        .then(response => {
          this.getBuild()
          this.updateBasket()
          event.target.classList.remove('loading')
        })
        .catch(e => {
          this.errors.push('Die Zutaten konnten nicht geändert werden 😭')
          event.target.classList.remove('loading')
        })
    },

    removeingredient (ingredientId) {
      axios.post(endpoints.removeIngredient, {
        'buildId': Number(this.$route.params.id),
        'ingredientId': Number(ingredientId)
      })
        .then(response => {
          this.getBuild()
          this.updateBasket()
        })
        .catch(e => {
          this.errors.push('Die Zutaten konnten nicht geändert werden 😭')
        })
    }
  }
}
</script>

<style lang="scss" scoped>
  .generator_base {
    [data-type="pizza"] & {
      background-image: url('https://api.foodi.de/content/pictures/generator/pizza_ground.png');
    }

    [data-type="salad"] & {
      background-image: url('https://api.foodi.de/content/pictures/generator/salad_ground.png');
    }

    [data-type="burger"] & {
      background-image: none;
      min-height: 450px;

      @media only screen and (min-width: 450px) and (max-width: 767px) {
        min-height: 750px;
      }

      @screen md {
        min-height: 400px;
      }

      .ingredient {
        top: auto;

        &:first-child {
          .ingredient__image {
            &::before {
              content: '';
              background-image: url('https://api.foodi.de/content/pictures/generator/onburger/bun_base.svg');
              position: absolute;
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center 25px;
              width: 100%;
              height: 100%;
              z-index: -1;
            }
          }
        }
      }
    }

    .ingredient__image {
      position: absolute;
      background-size: contain;
      background-repeat: no-repeat;
      width: 100%;
      height: 100%;

      &:nth-child(1) {
        top: 0;
      }

      &:nth-child(2) {
        top: -15px;
      }

      &:nth-child(3) {
        top: -30px;
      }
    }
  }

  h2 {
    border-bottom: 3px solid #b1c800;
    padding-bottom: 10px;
    &.ingredients {
      border: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/generator/index.vue